import { Directive, ElementRef, Input, AfterViewInit, ChangeDetectorRef, Optional } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[overflowTooltip]'
})
export class OverflowTooltipDirective implements AfterViewInit {
  @Input('overflowTooltip') text = '';

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
    @Optional() private matTooltip: MatTooltip
  ) {}

  ngAfterViewInit() {
    const el = this.el.nativeElement;
    const isOverflowing = el.scrollWidth > el.clientWidth;

    if (this.matTooltip) {
        // Set tooltip message only if text overflows, otherwise no tooltip
        this.matTooltip.message = isOverflowing ? this.text : '';

        // Position tooltip on the right
        this.matTooltip.position = 'right';
    }

    // No manual show()/hide() here — tooltip shows only on hover by Angular Material

    this.cdr.detectChanges();
  }
}
